"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_LEGEND_TYPE = void 0;
require("react");
require("../../../core");
var CHART_LEGEND_TYPE;
(function (CHART_LEGEND_TYPE) {
    CHART_LEGEND_TYPE["none"] = "none";
    CHART_LEGEND_TYPE["percent"] = "percent";
    CHART_LEGEND_TYPE["total"] = "total";
    CHART_LEGEND_TYPE["custom"] = "custom";
})(CHART_LEGEND_TYPE = exports.CHART_LEGEND_TYPE || (exports.CHART_LEGEND_TYPE = {}));
//# sourceMappingURL=types.js.map